import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  ReferenceManyField,
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  SingleFieldList,
  TextField,
  EditButton,
  required,
  ImageField,
  Create,
} from "react-admin";
import ColorInput from "../../components/color/color-input";
import ImageInput from "../../components/image/image-input";

export const ThemeList = () => (
  <List resource="theme">
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="description" />
    </Datagrid>
  </List>
);

export const ThemeCreate = (props) => (
  <Create  {...props}>
    <SimpleForm>
      <TextInput  label="Name" source="name" />
      <TextInput  label="Description" source="description" />
      <TextInput  label="Primary Color" source="primaryColor" />
      <TextInput  label="Secondary Color" source="secondaryColor" />
      <ImageInput  label="Login" source="brandImages.loginBackground" fullWidth="true"/>
      <ImageInput  label="Logo" source="brandImages.logo" />
    </SimpleForm>
  </Create>
);

export const ThemeEdit = props =>(
  <Edit {...props}>
    <SimpleForm>
      <TextInput  label="Name" source="name" />
      <TextInput  label="Description" source="description" />
      <ColorInput label="Primary Color" source="primaryColor" />
      <ColorInput  label="Secondary Color" source="secondaryColor"/>
      <ImageInput  label="Login Image" source="brandImages.loginBackground" />
      <ImageInput  label="Logo Image" source="brandImages.logo" />
    </SimpleForm>
  </Edit>
);